// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2IiA8","requiredAsterisk":"Info_requiredAsterisk__GIRGe"};